/**
 * Timekeeper reducer
 */

// Constants
import UPDATE_TIME from './constants';

type Action = {
    +type: string,
    +payload: Object
};

const initialState = '';

function timekeeperReducer(state?: string = initialState, action?: Action) {
    if (!action) return state;
    switch (action.type) {
        case UPDATE_TIME:
            return action.payload.time;
        default:
            return state;
    }
}

export default timekeeperReducer;
